import * as i from "react";
import { P as o } from "./index-CpDnqHCm.js";
import { jsx as t } from "react/jsx-runtime";
var d = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), s = "VisuallyHidden", e = i.forwardRef(
  (r, a) => /* @__PURE__ */ t(
    o.span,
    {
      ...r,
      ref: a,
      style: { ...d, ...r.style }
    }
  )
);
e.displayName = s;
var n = e;
export {
  n as R,
  d as V
};
//# sourceMappingURL=index-DfNPZZ8M.js.map
